export enum USER_ACCESS_LEVEL {
  FREE = "FREE",
  PRO = "PRO",
  ALL_ACCESS = "ALL ACCESS",
  PRO_AI = "PRO AI",
}
